import type {
    LogoutCommerceCustomerRequest,
    LogoutCommerceCustomerResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const logoutCommerceCustomerOperation = defineCommerceOperation<
    LogoutCommerceCustomerRequest,
    LogoutCommerceCustomerResponse
>("commerce.customer.logout");
